import { render, staticRenderFns } from "./Siniestro.vue?vue&type=template&id=47eeeede&"
import script from "./Siniestro.vue?vue&type=script&lang=js&"
export * from "./Siniestro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports